// extracted by mini-css-extract-plugin
export default {"container":"StyledParagraph_container__pJaXo","headline":"StyledParagraph_headline__BbZAW","text":"StyledParagraph_text__9iNPE"};